<template>
	<div>
		<header class="flex-apart">
			<h1 class="alpha heavy">Users</h1>
			<div>
				<ul>
					<li><router-link
						:to="{name: 'users.create'}" class="button button--primary--small">Create User</router-link>
					</li>
				</ul>
			</div>
		</header>
		<div>
			<loader v-if="!loaded"/>
			<div v-if="loaded" class="section--floating">
				<table-filter :filters="filters"/>
				<div v-if="loaded && !items.length" class="nothing-to-see-here">
					<p>Nothing to display.</p>
				</div>
				<v-table v-if="items.length" :loading="gettingModels">
					<thead>
						<tr>
							<th align="left">Name</th>
							<th align="left">Email</th>
							<th align="left">Verified</th>
							<th align="left">Last Login</th>
							<th align="right" class="actions"><span>Actions</span></th>
						</tr>
					</thead>
					<tfoot>
						<tr>
							<th align="left">Name</th>
							<th align="left">Email</th>
							<th align="left">Verified</th>
							<th align="left">Last Login</th>
							<th align="right" class="actions"><span>Actions</span></th>
						</tr>
					</tfoot>
					<tbody>
						<tr v-for="(item, index) in items">
							<td v-html="$present('fullName', item.profile)"></td>
							<td v-html="item.email"></td>
							<td v-html="$present('date', item.email_verified_at)"></td>
							<td v-html=""></td>
							<td align="right">
								<v-contextual :processing="startingImpersonation(item)">
									<v-contextual-option
										v-if="$can('view', item)"
										:route-to="{name: 'users.show', params: {user: item.id}}">View</v-contextual-option>
									<v-contextual-option
										v-if="$can('update', item)"
										:route-to="{name: 'users.edit', params: {user: item.id}}">Edit</v-contextual-option>
									<v-contextual-option
										v-if="$can('impersonate', item)"
										@click="impersonate(item)">Impersonate</v-contextual-option>
								</v-contextual>
							</td>
						</tr>
					</tbody>
				</v-table>
				<paginator :links="links" :meta="meta"/>
			</div>
		</div>
	</div>
</template>
<script>
import Index from "../../../../components";

let index = new Index("users");

export default {
	data() {
		return {
			impersonating: null,
		};
	},

	computed: {
		...index.computed(),
	},

	methods: {
		...index.actions(),
		startingImpersonation(user) {
			return this.impersonating === user.id;
		},
		impersonate(user) {
			this.impersonating = user.id;
			this.$store.dispatch("authStore/impersonate", user.id).then(() => {
				this.impersonating = null;
			});
		},
	},

	created() {
		this.filter(this.$route.query);
	},
};
</script>
